import { Injectable } from '@angular/core';

import { filter, merge, Observable, tap } from 'rxjs';

import { User } from '@shared/user/models';
import { WebSocketEventsEnum } from '@shared/websocket';
import { UserApiService } from '@tablesready/frontend-auth';
import { SocketService } from './socket.service';
import { AuthUserQuery, AuthUserStore } from '../states';

@Injectable({providedIn: 'root'})
export class AuthUserService {
  constructor(
    private readonly userApiService: UserApiService,
    private readonly query: AuthUserQuery,
    private readonly store: AuthUserStore,
    private readonly socketService: SocketService,
  ) {
  }

  load(): Observable<User> {
    return this.userApiService.get().pipe(tap(user => this.store._setState(user)));
  }

  reset() {
    this.store.reset();
  }

  select(): Observable<User | null> {
    return this.query.select();
  }

  get(): User | null {
    return this.query.getValue();
  }

  listenToChanges(): Observable<User | string[]> {
    return merge(
      this.socketService.getEventStream<User>(WebSocketEventsEnum.userUpdated)
        .pipe(tap(user => this.store.update(user))),
      this.socketService.getEventStream<string[]>(WebSocketEventsEnum.userDeleted)
        .pipe(
          filter(userId => userId.filter(id => id === this.store.getValue()._id).length > 0),
          tap(() => this.store.update({_id: null})),
        ),
    );
  }
}
